module.exports = __webpack_public_path__ + "img/GDP-1.bbf6a669.jpg";